import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, } from 'react';
import { EKeyCode } from 'Shared/consts';
import { AutocompleteField, FilterWrapper } from 'Shared/components';
import styles from './FilterByTextWithAutocomplete.css';
const getOption = (option) => option;
export const FilterByTextWithAutocomplete = ({ options, onChange, getOptionLabel = getOption, getOptionValue = getOption, placeholder, value, className, disabled, label, dataTestId, }) => {
    const handleBlur = useCallback((event) => {
        const { value: inputValue } = event.target;
        const trimmedValue = inputValue.trim();
        const isTrimmedValue = !!trimmedValue.length;
        if (!isTrimmedValue) {
            onChange(null);
        }
        else {
            onChange(trimmedValue);
        }
    }, [onChange]);
    const handleKeyDown = useCallback((event) => {
        if (event.code === EKeyCode.Enter) {
            handleBlur(event);
        }
    }, [handleBlur]);
    return (_jsx(FilterWrapper, Object.assign({ label: label, id: placeholder, className: className, dataTestId: dataTestId }, { children: _jsx(AutocompleteField, { className: styles.layout, inputClassName: styles.input, options: options, onChange: onChange, onBlur: handleBlur, onKeyDown: handleKeyDown, getOptionLabel: getOptionLabel, getOptionValue: getOptionValue, placeholder: placeholder, value: value, disabled: disabled, optionsListClassName: styles.dropdown }, void 0) }), void 0));
};
export default memo(FilterByTextWithAutocomplete);
